import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link } from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Topo from '../Layout/Topo';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import RequestApi from '../Miscelania/RequestApi';

const PropTypes = require('prop-types');

class ExamEdit extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  
  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      questoes: {},
      questoes_respondidas: 0
    };
    this.desativar_loading = this.desativar_loading.bind(this);
    this.abrirQuestao = this.abrirQuestao.bind(this);
    this.finalizarProva = this.finalizarProva.bind(this);
  }
  
  componentDidMount () {
    var verifica_prova = this.props.verificaProva();
    var self = this;
    Promise.resolve(verifica_prova).then(function(value) {
      if (verifica_prova === true) {
        self.setState({questoes: self.props.dadosProva});
      } else {
        self.context.router.history.push('/usuario/provas');
      }
    });
  }

  componentWillReceiveProps(newProps) {
    this.setState({questoes_respondidas: newProps.questoesFeitas});
  }

  render() {
    var self = this;
    return (
<div>
  <Topo dadosQuestoes={self.props.dadosProva} questoesFeitas={this.props.questoesFeitas}></Topo>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading !== 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {(this.state.status_alerta === 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
</div>
    );
  }
}
ExamEdit.contextTypes = {
  router: React.PropTypes.object.isRequired
}
export default ExamEdit;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamEdit.js